import React, { useEffect, useState } from 'react';
import {parseDate, daysDistance} from '@/utils/time';
import styles from './index.less';
import { TLang } from '@/utils/lang';
interface ITimeTab {
  data:Array<any>;
  onClick:any;
  discountShowDates: any;
}

interface IDataItem {
  label:string,
  date:string,
  status?:boolean,
  origin?:string
}
const TimeTab = (props: ITimeTab):JSX.Element => {
  const {data, discountShowDates} = props;
  // useEffect(()=>{
  //   let arr:Array<IDataItem>=[];
  //   props.data.forEach(i=>{
  //     const d = daysDistance(i)
  //     if(d>-1){
  //       const info:IDataItem = parseDate(i);
  //       arr.push(info);
  //     }
  //   })
  //   arr.length && arr.forEach((item,idx)=>{
  //     if(idx==0){
  //       item.status=true
  //     }else{
  //       item.status=false
  //     }
  //   })
  //   setNewData(arr);
  //   // 默认选中第一个。同时告诉父组件
  //   arr.length&&props.onClick && props.onClick(arr[0],0);

  // },[props.data]);
  const clickHandle = (item:IDataItem):void => {
    // const newArr = [...newData];
    // newArr.forEach((obj)=>{
    //   if(obj.origin === item.origin){
    //     obj.status = true;
    //   }else{
    //     obj.status = false;
    //   }
    // })
    // setNewData(newArr);
    props.onClick && props.onClick(item);
  };
  useEffect(() => {
    // 默认选中日期超出屏幕宽度，导致看不见，横向滚动到中间
    let idx = 0;
    if(data && data.length > 0){
      data.forEach((item, i) => {
        if(item.status ){
          idx = i;
        }
      });
      const cDayItem:any = document.querySelector(`#dayItem${idx}`);
      const cDayItemRact:any = cDayItem.getBoundingClientRect();
      const ww = document.documentElement.clientWidth;
      const sLeft = cDayItemRact.left;
      const sWight = cDayItemRact.width;
      if(sLeft + sWight/2 <= ww){
        return;
      }
      const offsetleft = cDayItem.offsetLeft;
      const offsetWidth = cDayItem.offsetWidth;
      const srollLeft = offsetleft - ww / 2 + offsetWidth / 2;
      const scrollDom:any = document.querySelector('#timeTabWrapper');
      scrollDom.scrollLeft = srollLeft;
    }
  }, [data]);

  const isCinema = window.location.pathname === '/newmovie/cinema';

  return <div className={styles.timeTabWrapper} id="timeTabWrapper">
    {
      data.length>0&&data.map((item, idx) => <div  style={{width:'auto', textAlign:'left'}} className={`${styles.dayItem}  ${item.status&&styles.active}`} id={`dayItem${idx}`} key={idx} onClick={() => clickHandle(item)}>
        <span>
          {item.label}
          {isCinema && Array.isArray(discountShowDates) && discountShowDates.includes(item?.origin) ? <div className={styles.discount}>{TLang('折', 'home', false, false, null)}</div> : null}
        </span>
        <span style={{textAlign:'left'}}>{item.date}</span>
      </div>)
    }
  </div>;
};
export default TimeTab;
